import type { ReactNode } from "react";
import { Link } from "react-router";
import {
  ArticleHeader,
  TableOfContents,
} from "@/components/Wiki/WikiComponents";

type ArticleHeaderProps = {
  eyebrow?: string;
  title: string;
  lede?: string;
  type?: string;
  readTime?: string;
  updated?: string;
  author?: string;
};

type WikiPageShellProps = {
  backTo?: string;
  backLabel?: string;
  header: ArticleHeaderProps;
  tocItems?: Array<{ id: string; label: string }>;
  children: ReactNode;
};

export function WikiPageShell({
  backTo = "../..",
  backLabel = "Back to Wiki",
  header,
  tocItems,
  children,
}: WikiPageShellProps) {
  return (
    <div className="wiki-markdown mx-auto max-w-[calc(100%-72px)] overflow-visible bg-transparent px-9">
      <div className="article-layout overflow-visible">
        <article className="article">
          <Link className="article__back" to={backTo} relative="path">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M19 12H5m7-7l-7 7 7 7" />
            </svg>
            {backLabel}
          </Link>

          <ArticleHeader {...header} />

          <div className="md article__body">{children}</div>
        </article>

        {tocItems?.length ? <TableOfContents items={tocItems} /> : null}
      </div>
    </div>
  );
}
